import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import chevronGreyIcon from 'assets/images/icons/chevron-grey.svg';
import { useTranslation } from 'react-i18next';
import MultiLevelSelect from 'components/form-components/MultiLevelSelect';

const SetDropdown = ({ data, headerData, column, callback }) => {
  const { t } = useTranslation();
  const [optionsList, setOptionsList] = useState([]);
  const [setId, setSetId] = useState(null);

  const handleChange = (name, val) => {
    const selectidOptionItem = optionsList.filter((singleOption) => singleOption.value === val);
    callback.updateTableData(
      data.formId || data.form_id,
      column,
      data.element_global_id,
      headerData.setType,
      column === 'topics' ? val : setId,
      val,
      val === '' ? '' : selectidOptionItem[0].displayValue,
    );
  };

  useEffect(() => {
    if (column === 'topics') {
      const selectedSet = callback.topicsList;
      let selectionList = [{ value: '', displayValue: 'select_select' }];
      if (selectedSet.length > 0) {
        setSetId(selectedSet[0]._id);
        selectedSet.map((singleOption) =>
          selectionList.push({ value: singleOption._id, displayValue: singleOption.title }),
        );
        setOptionsList(selectionList);
        // console.log(selectionList);
      }
    } else {
      const setList = callback.setsList;
      const selectedSet = setList.filter(
        (singleSet) => singleSet.sqlColumn.toLowerCase() === column.toLowerCase(),
      );
      let selectionList = [{ value: '', displayValue: 'select_select' }];
      if (selectedSet.length > 0) {
        setSetId(selectedSet[0]._id);
        selectedSet[0].options.map((singleOption) =>
          selectionList.push({ value: singleOption._id, displayValue: singleOption.optionValue }),
        );
        setOptionsList(selectionList);
      }
    }
  }, [callback.setsList]);

  return (
    <MultiLevelSelect
      options={{ children: optionsList }}
      value={[]}
      name='setsInnerOptions'
      handleChange={(name, value) => handleChange(name, value[0])}
      toggleClasses='px-2 py-2 d-flex gap-2 justify-content-between align-items-center rounded-sm cursor-pointer border-grey-1-h-1'
      toggleComponent={
        <>
          <label className='theme-size-0_9 cursor-pointer '>
            {data[column] || t('select_select')}
          </label>
          <img src={chevronGreyIcon} className='rotate-180' />
        </>
      }
    />
  );
};

SetDropdown.propTypes = {
  callback: PropTypes.object,
  headerData: PropTypes.object,
  data: PropTypes.object,
  column: PropTypes.string,
};
export default SetDropdown;
